class Animation {
  initPearWidgetObserver() {
    const pearTarget = document.getElementById('pear-pdp-target')
    if (!pearTarget) {
      return
    }

    const clearPearLoadingPlaceholder = () => {
      if (!pearTarget.classList.contains('pear-pdp-target--loading')) {
        return
      }

      const iframe = pearTarget.querySelector('iframe')
      if (!iframe) {
        return
      }

      const wrap = iframe.parentElement
      const wrapVisible = wrap && getComputedStyle(wrap).display !== 'none'
      const iframeHeight = iframe.getBoundingClientRect().height

      if (wrapVisible && iframeHeight > 40) {
        pearTarget.classList.remove('pear-pdp-target--loading')
        pearTarget.setAttribute('aria-busy', 'false')
      }
    }

    const setPearIframeHeight = (nextHeight) => {
      if (!nextHeight || Number.isNaN(nextHeight)) {
        return
      }
      const height = Math.max(300, Math.floor(nextHeight))
      const iframe = pearTarget.querySelector('iframe')
      if (!iframe) {
        return
      }

      iframe.style.height = `${height}px`
      iframe.setAttribute('height', `${height}px`)

      let el = iframe.parentElement
      while (el && el !== pearTarget.parentElement) {
        el.style.height = `${height}px`
        el.style.minHeight = `${height}px`
        el = el.parentElement
      }

      pearTarget.style.minHeight = `${height}px`
      clearPearLoadingPlaceholder()
    }

    let refreshTimeout = null
    let isRefreshing = false
    let didFinalRefresh = false
    let lastHeight = pearTarget.getBoundingClientRect().height
    let idleTimer = null
    const settleDelay = 600

    const finalizeRefresh = () => {
      if (didFinalRefresh) {
        return
      }
      didFinalRefresh = true
      isRefreshing = true
      this.normalizePearRetailerList()
      clearPearLoadingPlaceholder()

      setTimeout(() => {
        isRefreshing = false
        clearPearLoadingPlaceholder()
      }, 300)

      observer.disconnect()
      if (resizeObserver) {
        resizeObserver.disconnect()
      }
    }

    const scheduleFinalRefresh = () => {
      clearTimeout(refreshTimeout)
      refreshTimeout = setTimeout(() => {
        finalizeRefresh()
      }, 200)
    }

    const scheduleIdleCheck = () => {
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => {
        finalizeRefresh()
      }, settleDelay)
    }

    pearTarget.addEventListener('click', (event) => {
      const target = event.target
      if (target && target.id === 'showMoreButton') {
        setTimeout(() => {
          this.normalizePearRetailerList()
        }, 150)
      }
    })

    let lastPearHeight = 0

    window.addEventListener('message', (event) => {
      if (!event.origin || !event.origin.includes('pearcommerce.com')) {
        return
      }

      let payload = event.data
      let height = null

      if (typeof payload === 'string' && payload.includes('xPYMx')) {
        const parts = payload.split('xPYMx')
        const heightIndex = parts.indexOf('height')
        if (heightIndex !== -1 && parts[heightIndex + 1]) {
          height = parseFloat(parts[heightIndex + 1])
        }
      } else if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload)
        } catch {
          height = parseFloat(payload)
        }
      }

      if (typeof payload === 'number') {
        height = payload
      }

      if (payload && typeof payload === 'object') {
        height = parseFloat(
          payload.height
          || payload.iframeHeight
          || payload.documentHeight
          || payload.contentHeight
          || payload.data?.height
        )
      }

      if (height && !Number.isNaN(height) && height > 50 && Math.abs(height - lastPearHeight) > 1) {
        lastPearHeight = height
        setPearIframeHeight(height)
      }
    })

    const watchIframeAttributes = () => {
      const iframe = pearTarget.querySelector('iframe')
      if (!iframe) {
        setTimeout(watchIframeAttributes, 200)
        return
      }

      let lastObservedHeight = iframe.getAttribute('height')

      const iframeObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'height') {
            const newHeight = iframe.getAttribute('height')
            if (newHeight !== lastObservedHeight) {
              lastObservedHeight = newHeight
            }
          }
        })
      })

      iframeObserver.observe(iframe, {
        attributes: true,
        attributeFilter: ['height', 'style']
      })
    }
    watchIframeAttributes()

    const observer = new MutationObserver(() => {
      clearPearLoadingPlaceholder()
      if (isRefreshing || didFinalRefresh) {
        return
      }
      scheduleFinalRefresh()
      scheduleIdleCheck()
    })

    observer.observe(pearTarget, {
      childList: true,
      subtree: true
    })

    let resizeObserver = null
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver((entries) => {
        clearPearLoadingPlaceholder()
        if (isRefreshing || didFinalRefresh) {
          return
        }
        const nextHeight = entries[0].contentRect.height
        if (Math.abs(nextHeight - lastHeight) < 1) {
          return
        }
        lastHeight = nextHeight
        scheduleFinalRefresh()
        scheduleIdleCheck()
      })
      resizeObserver.observe(pearTarget)
    }

    const loadingPoll = window.setInterval(() => {
      clearPearLoadingPlaceholder()
      if (!pearTarget.classList.contains('pear-pdp-target--loading')) {
        window.clearInterval(loadingPoll)
      }
    }, 250)

    window.setTimeout(() => {
      window.clearInterval(loadingPoll)
    }, 30000)

    scheduleFinalRefresh()
    scheduleIdleCheck()
  }

  normalizePearRetailerList() {
    const list = document.querySelector('#pear-pdp-target .retailer-list-container')
    if (!list) {
      return
    }

    list.style.position = 'static'
    list.style.height = 'auto'
    list.style.maxHeight = 'none'
    list.style.overflow = 'visible'

    const items = list.querySelectorAll(':scope > li')
    items.forEach((item) => {
      item.style.position = 'static'
      item.style.top = 'auto'
      item.style.left = 'auto'
      item.style.transform = 'none'
      item.style.opacity = '1'
    })
  }

  init() {
    this.initPearWidgetObserver()
  }
}

export { Animation }
